import { defineMessages } from 'react-intl';

export default defineMessages({
  issuesReasonsTitlePage: {
    id: 'view.myaccount.step.issuesReasons.issuesReasonsTitlePage',
    defaultMessage: 'Issues Reasons',
  },
});
